import React, { PureComponent, Fragment } from 'react'
import { Auth } from 'aws-amplify'
import { injectIntl, intlShape, FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createBooking } from '../actions/bookingActions'
import BookingBreadcrumb from '../components/BookingBreadcrumb'
import Cart from '../components/BookingCart'
import AuthenticatedAPI from '../lib/authenticatedAPI'
import BookingLib from '../lib/booking'

class BookingCompletedPage extends PureComponent {
  constructor(props){
    super(props)

    this.handleLogout = this.handleLogout.bind(this)
    this.state = {
      overrideHours: []
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0); // TODO avoid duplication on all pages
  }

  async componentDidMount() {
    const { props } = this
    this.setOverrideHours()
    try {
      const userInfo = await AuthenticatedAPI.get('cphill', '/users')
      this.setState({ email: userInfo.email })
      try {
        window.Autopilot.run("associate", {
          Email: userInfo.email,
          FirstName: userInfo.firstName,
          LastName: userInfo.lastName,
          custom: {
            'date--Booking--Date': props.booking.whenStartTime.toISOString().split('T')[0]
          }
        })
      } catch(error) { /* Do nothing */}
    } catch (error) {
      console.error(error)
    }
  }

  async setOverrideHours() {
    const overrideHours = await BookingLib.getOverrides()
    this.setState({ overrideHours })
  }

  gotoDashboard() {
    const {props} = this
    props.history.push('/dashboard')
  }

  async handleLogout() {
    const {props} = this
    await Auth.signOut()
    props.history.push('/bookings')
  }

  render() {
    const { booking, skus, intl } = this.props
    const { overrideHours, email } = this.state
    
    return (

      <Fragment>

        <BookingBreadcrumb booking={booking} step={6} />

        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
            <h4 className="text-harbor-80 uppercase text-sky">
              <FormattedMessage
                id="booking.completed.category"
                defaultMessage="New booking"
              />
            </h4>

            <h1 className="border-b pb-6 mb-6">
              <FormattedMessage
                id="booking.completed.header"
                defaultMessage="Booking completed"
              />
            </h1>

            <div className="flex flex-col">
              <div className="md:flex flex-row border-b mb-6">
                <div className="flex flex-col md:mr-12">
                  <h4>
                    <FormattedMessage
                      id="booking.completed.mybookings.title"
                      defaultMessage="My bookings"
                    />
                  </h4>
                  <p>
                    <FormattedMessage 
                      id="booking.completed.mybookings.description" 
                      defaultMessage="An overview of your participants and future bookings. This is also where you'll find the QR-codes necessary to pick up your keycard the first time you visit the Hill."
                    />
                  </p>
                </div>
                <div className="pb-4 mb-1 md:self-end flex flex-row-reverse">
                  <Link to="/dashboard" className="bg-grass whitespace-no-wrap font-bold text-white italic rounded-full uppercase leading-normal tracking-wide focus:outline-none py-2 px-4 sm:py-4 sm:px-8 text-lg">
                    <FormattedMessage id="booking.completed.buttons.mybookings" defaultMessage="My bookings" />
                  </Link>
                </div>
              </div>
              <div className="md:flex flex-row border-b mb-6">
                <div className="flex flex-col md:mr-12">
                  <h4>
                    <FormattedMessage
                      id="booking.completed.skiinstructions.title"
                      defaultMessage="Do you need an instructor?"
                    />
                  </h4>
                  <p>
                    <FormattedMessage 
                      id="booking.completed.skiinstructions.description"
                      defaultMessage="Make your experience on the Hill truly unique with a private ski or snowboard instructor or join group instructions and learn with others."
                    />
                  </p>
                </div>
                <div className="pb-4 mb-1 md:self-end flex flex-row-reverse">
                  <a 
                    className="bg-grass whitespace-no-wrap font-bold text-white italic rounded-full uppercase leading-normal tracking-wide focus:outline-none py-2 px-4 sm:py-4 sm:px-8 text-lg" 
                    href={intl.formatMessage({id: 'booking.completed.bookinstructionsurl', defaultMessage: 'https://www.skischoolsnowmindscopenhill.dk'})}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage id="booking.completed.buttons.bookinstructions" defaultMessage="BOOK INSTRUCTOR" />
                  </a> 
                </div>
              </div>
              <div className="md:flex flex-row justify-between mb-6">
                <div className="flex flex-col md:mr-8">
                  <h4>
                    <FormattedMessage
                      id="booking.completed.logout.title"
                      defaultMessage="Remember to log out"
                    />
                  </h4>
                  <p>
                    <FormattedMessage id="booking.completed.logout.description" defaultMessage="Remember to log out if you were booking from a public device." />
                  </p>
                </div>
                <div className="pb-4 mt-8 md:self-end flex flex-row-reverse">
                  <button 
                    type="button" 
                    className="whitespace-no-wrap font-bold text-grass underline mr-6 uppercase leading-normal tracking-wide"
                    onClick={this.handleLogout}
                  >
                    <FormattedMessage id="booking.amountForm.signedInBlock.signout" defaultMessage="Log out" />
                  </button>
                </div>
              </div>
            </div>
 
            {skus.length > 0 && (
              <Cart skus={skus} overrideHours={overrideHours} email={email} />
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

BookingCompletedPage.propTypes = {
  booking: PropTypes.shape({ booking: PropTypes.object }).isRequired,
  skus: PropTypes.arrayOf(PropTypes.object),
  intl: intlShape.isRequired
}

BookingCompletedPage.defaultProps = {
  skus: []
}

const mapStateToProps = state => ({
  booking: state.booking,
})

export default connect(mapStateToProps, { createBooking })(injectIntl(BookingCompletedPage))